module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stateName != 'login' && _vm.stateName != 'resetpassword' && _vm.stateName != 'signup' && _vm.stateName != 'signupconfirm' && _vm.sidebar == true) ? _c('div', {
    staticClass: "side-bar1 right-bar1"
  }, [_c('a', {
    staticClass: "right-bar-toggle",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o"
  })]), _vm._v(" "), _c('h4', {}, [_vm._v("Notifications")]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-list nicescroll"
  }, [_c('ul', {
    staticClass: "list-group list-no-border user-list"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "user-list-item"
  }, [_c('div', {
    staticClass: "icon bg-danger"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-desc"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("High Chlorine")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("High Chlorine reported")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v("2 hours ago")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "user-list-item"
  }, [_c('div', {
    staticClass: "icon bg-info"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-desc"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Low Calcium Hardness")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("Low Calcium Hardness reported")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v("5 hours ago")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "user-list-item"
  }, [_c('div', {
    staticClass: "icon bg-pink"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-desc"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Incident on pool deck")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("There was an incident at...")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v("1 day ago")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item active"
  }, [_c('a', {
    staticClass: "user-list-item"
  }, [_c('div', {
    staticClass: "icon bg-success"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-desc"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("New Pool Log ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("New pool log added")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v("2 days ago")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item active"
  }, [_c('a', {
    staticClass: "user-list-item"
  }, [_c('div', {
    staticClass: "icon bg-pink"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-desc"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Low pH value")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("Low pH value detected")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v("3 days ago")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf164f04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationSidebar/notification_sidebar.vue
// module id = 849
// module chunks = 1